import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const ShoppingBag24: FC<IconV2Props> = ({ icon, chroma, className }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight24 : s.svgDark24,
      `svg-icon--${icon}`,
      className
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
  >
    <path
      fill="#000"
      fillRule="nonzero"
      d="M11.891 3.703c2.153 0 3.45 1.637 3.96 4.296L21 8v12H3V8h4.931c.511-2.66 1.807-4.297 3.96-4.297ZM20 9h-3.998c.068.61.102 1.263.102 1.953h-1c0-.702-.037-1.355-.11-1.954H8.789a16.334 16.334 0 0 0-.11 1.954h-1c0-.69.035-1.342.103-1.953H4v10h16V9Zm-8.109-4.298c-1.497 0-2.49 1.209-2.938 3.298h5.877c-.449-2.09-1.442-3.298-2.939-3.298Z"
    />
  </svg>
);

export default ShoppingBag24;
